import { Injectable } from '@angular/core';
import { toDataURL } from 'qrcode';

/** Generates QR codes on the device — no third-party QR service sees the encoded text. */
@Injectable({ providedIn: 'root' })
export class QrCodeService {
  /** PNG data URL of `text` encoded as a QR code, `sizePx` square. */
  toPngDataUrl(text: string, sizePx: number): Promise<string> {
    return toDataURL(text, { width: sizePx, margin: 2 });
  }
}
